import styled from '@emotion/styled';
import {SentimentSatisfied, SentimentVeryDissatisfied, SentimentVerySatisfied} from '@mui/icons-material';
import {Rating, Typography} from '@mui/material';
import {useState} from 'react';
import React from 'react';

const size = 35;
const customIcons = {
    1: {
        icon: <SentimentVeryDissatisfied style={{fontSize: size}} />,
        label: 'Unzufrieden',
    },
    2: {
        icon: <SentimentSatisfied style={{fontSize: size}} />,
        label: 'Neutral',
    },
    3: {
        icon: <SentimentVerySatisfied style={{fontSize: size}} />,
        label: 'Zufrieden',
    },
};

const StyledRating = styled(Rating)(({theme, color}) => {
    return {
        '& .MuiRating-iconFilled': {
            color: theme.palette[color].main,
        },
        '& > *': {
            '&:last-child': {
                display: 'none',
            },
            '&:nth-of-type(3)': {
                paddingRight: '0',
            },
            paddingRight: '2rem',
        },
    };
});

function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
}

export default function CustomRating(props) {
    const [hoverValue, setHoverValue] = useState(null);

    return (<>
        <StyledRating
            IconContainerComponent={IconContainer}
            max={3}
            getLabelText={(value) => {
                return customIcons[value].label;
            }}
            emptyIcon={null}
            emptyLabelText={null}
            onChangeActive={(event, value) => setHoverValue(value)}
            highlightSelectedOnly
            {...props}
        />
        <Typography sx={{textAlign: 'center'}} variant={'body2'}>
            {hoverValue && hoverValue in customIcons ? customIcons[hoverValue].label : props.value ? customIcons[props.value].label : 'Bitte Smiley wählen'}
        </Typography>
    </>);
}
